<template>
  <div class="nav-header">
    <img src="../../../static/logo.svg" alt="BingX API Docs" class="logo">
    <el-menu class="nav-header-menu" mode="horizontal" router font-size="0.9px" text-color="#999999"
      active-text-color="#292929" :default-active="defaultActive">
      <el-menu-item style="font-size: xx-small;" v-if="langLabel == 'English'" v-for="item in menus" :key="item.name"
        :index="item.path">
        {{ item.label }}
      </el-menu-item>
      <el-menu-item v-else :key="item.name + 1" :index="item.path">
        {{ item.label }}
      </el-menu-item>

      <el-menu-item v-if="langLabel == '简体中文'" key="LINK_ZH" index="LINK_ZH">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx.com/zh-tw/act/template/5302/?randomId=1871286856">经纪商招募</a>
      </el-menu-item>
      <el-menu-item v-else-if="langLabel == '繁体中文'" key="LINK_ZHTW" index="LINK_ZHTW">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx.com/zh-tw/act/template/5302/?randomId=1871286856">經紀商招募</a>
      </el-menu-item>
      <el-menu-item style="font-size: xx-small;" v-else key="LINK_EN" index="LINK_EN">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx.com/en-us/act/template/5302?randomId=1871286856">Broker</a>
      </el-menu-item>

      <el-menu-item v-if="langLabel == '简体中文'" key="LINK_API_ZH" index="LINK_API_ZH">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx-api.github.io/docs-v3/#/zh-tw/info">V3 API</a>
      </el-menu-item>
      <el-menu-item v-else-if="langLabel == '繁体中文'" key="LINK_API_ZHTW" index="LINK_API_ZHTW">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx-api.github.io/docs-v3/#/zh-tw/info">V3 API</a>
      </el-menu-item>
      <el-menu-item style="font-size: xx-small;" v-else key="LINK_API_EN" index="LINK_API_EN">
        <a style="color: rgb(153, 153, 153); border-bottom-color: transparent;margin-right: 3%;" target="_blank"
          href="https://bingx-api.github.io/docs-v3/#/en/info">V3 API</a>
      </el-menu-item>
    </el-menu>
    <el-select style="width: 190px;" v-model="value" :multiple="false" :loading="loading" :remote-method="debounceQuery"
      filterable remote no-data-text="No Data" no-match-text="No Data" loading-text="Loading..."
      :placeholder="placeholders[lang]" icon="el-icon-search" class="nav-header-search" popper-class="search-results">

      <template slot="prefix">
        <i class="el-icon-search"></i>
      </template>
      <el-option-group v-for="group in options" :key="group.label" :label="group.label">
        <el-option v-for="(item, index) in group.options" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-option-group>
      <!-- <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value" 
      /> -->
    </el-select>
    <el-dropdown class="nav-header-lang" trigger="click">
      <span style="cursor: pointer;">
        {{ langLabel }} <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in langs" :key="item.value" @click.native="handleChangeLang(item.value)">
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import debounce from 'lodash.debounce'
import groupBy from 'lodash.groupby'

import { getNavMenusByLang } from '@/config/index'
import { getModules, LANGS, updateAppConfigByLang, LANG_KEY, getSearchConfig } from '@/utils'

export default {
  props: {
    lang: String
  },

  data() {
    return {
      value: '',
      loading: false,
      options: [],
      langs: LANGS,
      placeholders: {
        [LANG_KEY.en]: 'Enter keywords to search...',
        [LANG_KEY.zh]: '输入关键字搜索...',
        [LANG_KEY.tw]: '輸入關鍵字搜索...',
      },
      debounceQuery: () => { },
      searchConfig: [],
    }
  },

  computed: {
    menus() {
      const modules = getModules(this.lang)
      const navTexts = getNavMenusByLang(this.lang)
      const res = []
      modules.forEach(item => {
        // conso(item.name)
        console.log(item)
        res.push({
          ...item,
          label: navTexts[item.name]
        })
      })
      return res
    },
    defaultActive() {
      const paths = this.$route.path.split('/')
      // alert(!paths[1] ? this.menus[0].path : `/${paths[1]}/${paths[2]}`)
      return !paths[1] ? this.menus[0].path : `/${paths[1]}/${paths[2]}`
    },
    langLabel() {
      const item = this.langs.find(i => i.value === this.lang)
      return item.label
    },

    moduleName() {
      return this.$route.meta.module
    },
  },

  watch: {
    lang: {
      handler() {
        this.searchConfig = getSearchConfig()
      },
      immediate: true
    },

    value(val) {
      if (!val) {
        return
      }
      const item = JSON.parse(val)
      if (this.$route.path === item.path) {
        this.resetSearch()
        return
      }
      this.$router.push({ path: item.path, hash: item.hash ? `#${item.hash}` : '' })
    },
    '$route.path'() {
      this.resetSearch()
    }
  },

  methods: {
    ...mapMutations(['changeLang']),

    resetSearch() {
      this.value = ''
      this.options = []
    },

    handleChangeLang(lang) {
      updateAppConfigByLang(lang)
      const path = location.hash.slice(1).replace(/(#.*)/, '')
      location.hash = `#${path}`
      this.changeLang(lang)
    },

    query(val) {
      if (!val.trim()) {
        return
      }

      this.loading = true
      let result = []
      val = val.toLowerCase()
      if (Array.isArray(this.searchConfig)) {
        this.searchConfig.forEach(config => {
          const item = Object.create(null)
          if (config.hash && config.hash.toLowerCase().includes(val)) {
            item.hash = config.hash
          }

          if (config.api && config.api.toLowerCase().includes(val)) {
            item.api = config.api
          }

          if (Array.isArray(config.texts)) {
            const matchedTexts = []
            config.texts.forEach(text => {
              if (text && text.toLowerCase().includes(val)) {
                matchedTexts.push(text)
              }
            })
            if (matchedTexts.length) {
              item.text = matchedTexts.join(',')
            }
          }

          if (Object.keys(item).length) {
            item.path = config.path
            item.name = config.name
            item.moduleName = config.moduleName
            result.push(item)
          }
        })
      }

      const opts = []
      if (result.length) {
        result = groupBy(result, 'moduleName')
        for (const [key, value] of Object.entries(result)) {
          const optItem = Object.create(null)
          optItem.label = key
          optItem.options = []
          if (value.length) {
            value.forEach(item => {
              let label = ''
              if (item.api) {
                label = `${item.name} -> ${item.api}`
              } else if (item.text) {
                label = `${item.name} -> ${item.text}`
              }
              if (label) {
                optItem.options.push({
                  label,
                  value: JSON.stringify(item)
                })
              }
            })
          }
          opts.push(optItem)
        }
      }
      this.options = [...opts]
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
  },

  created() {
    this.debounceQuery = debounce(this.query, 500)
  }
}
</script>

<style scoped>
.nav-header {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0px 48px 0px 12px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
}

.nav-header-menu {
  flex: 1;
  margin-left: 20px;
}

.nav-header-search {
  width: 288px;
}

.nav-header-search>>>.el-input__prefix {
  left: 10px;
  top: 10px;
}

.nav-header-lang {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/NavHeader/index.vue